import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { PromoSidebarWrapper, IframeStyle, IframeContent } from './PromoSidebar.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';
import { SpecialEvents } from 'src/domains/players/state/specialEventsState/SpecialEvents';
import { ModalState } from 'src/domains/layouts/webview/components/modals/Modal.state';

import { SidebarHeader } from './PromoSidebarPartials/SidebarHeader';
import { Overlay } from './PromoSidebarPartials/Overlay';
import { SidebarContent } from './PromoSidebarPartials/SidebarContent';
import { Terms } from './PromoSidebarPartials/Terms';
import { LazyImage } from 'src/domains/layouts/webview/components/common/lazyLoadingImage/LazyImage';

interface PropsType {
    promotionSlug: string;
}

export const PromoSidebar = observer('PromoSidebar', ({ promotionSlug }: PropsType) => {
    const common = useCommon();
    const appLayoutsState = AppLayoutsState.get(common);
    const { bannersBoxState } = appLayoutsState;
    const specialEvents = SpecialEvents.get(common);
    const modalState = ModalState.get(common);
    const isAnyLayerVisible = modalState.isAnyLayerVisible;
    const session = common.session;
    const configComponents = ConfigComponents.get(common);
    const starRouter = StarRouter.get(common);

    // TODO change after new singup
    const topOffset = bannersBoxState.boxHeight;
    const lpState = specialEvents.getLandingPageState(promotionSlug);
    const {
        promoLandingPage,
        shouldDisplay,
        isShowForUser,
        isHTMLBanner,
        actionTemplate,
        ctaText,
        ctaUrl,
        handleRedirectToLogin,
        handleRedirectToSignUp,
        closePromoSidebar,
        addToLocalStoreAndClose,
        lpImgHtmlUrl,
        lpImgUrl,
    } = lpState;

    const handleMatchUrl = (): void => {
        starRouter.handleUrlRedirection(ctaUrl);
        closePromoSidebar();
    };

    if (shouldDisplay === true && isShowForUser === true) {
        return (
            <>
                <Overlay
                    shouldDisplay={shouldDisplay}
                    isAnyLayerVisible={isAnyLayerVisible}
                />

                <PromoSidebarWrapper
                    topOffset={topOffset}
                    data-test='landing-page'
                >
                    <SidebarHeader
                        operatorName={configComponents.config.operatorFullName}
                        isUserAuthorized={common.session.isAuthorized}
                        onCloseHandle={actionTemplate === 'signup' ? addToLocalStoreAndClose : closePromoSidebar}
                        onSignUpHandle={handleRedirectToSignUp}
                        onLoginHandle={handleRedirectToLogin}
                    />

                    {isHTMLBanner && lpImgHtmlUrl !== null ? (
                        <>
                            <IframeStyle
                                src={lpImgHtmlUrl}
                                dataTest='landing-page-html-img'
                            />
                            <IframeContent>
                                <SidebarContent
                                    lpState={lpState}
                                    promotionSlug={promotionSlug}
                                    actionTemplate={actionTemplate}
                                    onClickDirectLinkHandle={handleMatchUrl}
                                    ctaText={ctaText}
                                    isUserAuthorized={session.isAuthorized}
                                    isHTMLBanner={true}
                                />
                                {promoLandingPage.type === 'ready' && promoLandingPage.value !== undefined && (
                                    <Terms tc_text={promoLandingPage.value?.tc_text} />
                                )}
                            </IframeContent>
                        </>
                    ) : lpImgUrl === null ? null : (
                        <>
                            <LazyImage
                                imgBase={{
                                    src: lpImgUrl,
                                    optimizeOptions: {
                                        quality: 85,
                                    },
                                }}
                                data-test='landing-page-static-img'
                            />
                            <SidebarContent
                                lpState={lpState}
                                promotionSlug={promotionSlug}
                                actionTemplate={actionTemplate}
                                onClickDirectLinkHandle={handleMatchUrl}
                                ctaText={ctaText}
                                isUserAuthorized={session.isAuthorized}
                                isHTMLBanner={false}
                            />
                            {promoLandingPage.type === 'ready' && promoLandingPage.value !== undefined && (
                                <Terms tc_text={promoLandingPage.value?.tc_text} />
                            )}
                        </>
                    )}
                </PromoSidebarWrapper>
            </>
        );
    }

    return null;
});
